import { NotifyContext, UserContext } from "context";
import React, { useContext } from "react";
import { injectIntl } from "react-intl";
import ControlPointsTable from "./ControlPointsTable";

const RoutePage = ({ ...props }) => {
  const { intl } = props;
  const { pushNotify } = useContext(NotifyContext);
  const { logout } = useContext(UserContext);

  return (
    <div className="route-page">
      <ControlPointsTable pushNotify={pushNotify} logout={logout} intl={intl} />
    </div>
  );
};

export default injectIntl(RoutePage);
